export * from './main';
export * from './constants';

import { List } from 'immutable';
import {
  SIMPLE,
  COMPACT,
} from './constants';

export const VOCAB_TYPES = List([
  SIMPLE,
  COMPACT,
]);
